import Cookies from "js-cookie"

import { IS_NA } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()
  const geoCookie = Cookies.get("geo")
  const isGeoUS = geoCookie === "US"
  const isGeoCA = geoCookie === "CA"

  return () => {
    try {
      if (IS_NA()) {
        const attentiveBoxID = isMobile
          ? isGeoUS
            ? 1306983 // US Mobile
            : isGeoCA
              ? 1311719 // CA Mobile
              : null
          : isGeoUS
            ? 1306982 // US Desktop
            : isGeoCA
              ? 1311567 // CA Desktop
              : null
        if (attentiveBoxID) {
          window.__attentive.trigger(null, null, null, attentiveBoxID)
        } else {
          alert(
            "Unable to detect your location. This offer is available to customers in the US and Canada only."
          )
        }
        // } else if (IS_INT()) {
        //   const globaleBoxID = "aee6786c-941d-4447-a7e9-74364ff13e18" // global e 321134
        //   window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        // const lightboxID = IS_UK()
        //   ? "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
        //   : "acb91908-2c05-44ab-a719-47b5633fff8e" // 325686

        // const lightboxID = IS_INT()
        //   ? "34635a3c-575b-4569-b7c4-2bb8e0d7f6f8" // 323529
        //   : IS_UK()
        //     ? "12e682df-8816-43a9-92b8-1ada528ab378" // 327631
        //     : "58602e79-1c74-4680-8adb-2697bb416cc6" // 327659

        const lightboxID = "7287ac89-4f12-4d89-bb96-1db09b4d911a" // 301215
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

export default usePopupTrigger
